var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',_vm._g(_vm._b({style:({width:_vm.width}),attrs:{"value":_vm.value},on:{"change":function (val){_vm.$emit('input',val)}}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.selectList),function(item,index){return _c('el-option',{key:item.value+index,attrs:{"label":item.label,"value":item.value}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7decb2b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/CSelect.vue
// module id = null
// module chunks = 